export default function Rewards() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Rewards</h1>
      <div className="card">
        <p className="text-gray-600">This is the Rewards page. Content coming soon...</p>
      </div>
    </div>
  );
}
